@if (!hideName) {
  <div style="font-size: 1.2em">{{ metaData.config.name }}</div>
}
@if (showId) {
  <div class="mt-1" style="font-size: 0.7em">
    {{ metaData.config.id }}
  </div>
}
@if (!hidePath) {
  <div class="mt-1" style="font-size: 0.7em">
    {{ baseUrl }}/#/APP/{{ metaData.fullPathFromRoot }}
  </div>
}
@if (showTopic && metaData.config.topic) {
  <div class="mt-1">
    <e-badge small color="secondary" textWhite class="mr-2">{{ metaData.config.topic }}</e-badge>
  </div>
}
@if (!hideDependencies && metaData.config.dependencies) {
  <div class="mt-1">
    @if (metaData.config.dependencies.poolName) {
      <e-badge
        small
        color="elegant"
        prependIcon='map-marker-alt'
        class="mr-2"
        >Poolnaam
      </e-badge>
    }
    @if (metaData.config.dependencies.machineName) {
      <e-badge small color="elegant">
        Machinenaam
      </e-badge>
    }
  </div>
}

@if (showPreview && metaData.config.previewImg) {
  <img
    class="mt-1"
    width="100%"
    [src]="metaData.config.previewImg"
    />
}
